export default "__VITE_ASSET__BqAg4BdI__"